module.exports = __webpack_public_path__ + "img/stage-3-motion.095d8001.png";